"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchStocks = exports.SEARCH_STOCKS = void 0;
const module_stock_interfaces_1 = require("@invivodf/module-stock-interfaces");
const errors_1 = require("../../errors");
const utils_1 = require("../../utils");
exports.SEARCH_STOCKS = '/v1/stocks/search';
const searchStocks = (client) => async (sellerId, customerId, storableIds) => {
    try {
        const response = await client.post(exports.SEARCH_STOCKS, {
            sellerId,
            customerId,
            storableIds
        });
        return response.data;
    }
    catch (error) {
        if ((0, utils_1.isFunctionalApiError)(error)) {
            switch (error.body.code) {
                case module_stock_interfaces_1.StockReadErrorCode.STOCK_READ_ERROR:
                    return new errors_1.StockReadErrorSdk(error.body);
                default:
                    throw error;
            }
        }
        throw error;
    }
};
exports.searchStocks = searchStocks;
